<template>
	<div class="box" v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading"
		element-loading-background="rgba(0, 0, 0, 0.8)">
		<Header navbar="hearKnowledge"></Header>
		<!-- <div class="fh" @click="goHome"><span style="color: #000;">
				<i class="el-icon-arrow-left"></i>返回</span></div> -->
		<el-button v-if="loading == false" style="position:fixed;right: 50px;top: 120px; z-index: 10000;" type="primary"
			@click="exportPDF">导出</el-button>
		<!-- <el-button v-if="loading == false" style="position:fixed;right: 50px;top: 180px; z-index: 10000" type="primary"
			@click="exportPDF2">导-截</el-button> -->

		<div id="preview" class="xxbg ">
			<div class="xxbg-title pdf-group-item">
				&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ list.specName }}专题报告
			</div>
			<div class="xxbg-title pdf-group-item">
				&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ list.companyName
				}}
			</div>
			<div class="xxbg-title2 pdf-group-item">
				&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;统计总览

			</div>
			<div class="tzxl pdf-group-item">
				<div
					style="border-radius: 4px;margin-bottom: 10px;width: 100%;height: 120px;display: flex;border: 1px solid #ccc;align-items: center;">
					<div class="tzxl_li tzxl_li1 " style="display: flex;margin-top: 50px;">
						<div class="tzxl_li_img"><img src="../../assets/img/zrs.png" alt=""></div>
						<div>
							<div class="tzxl_li_name">总人数</div>
							<div class="tzxl_li_num" style="max-width: 250px;">{{ list.totalUserCount }}人</div>
						</div>
					</div>
					<div class="tzxl_li tzxl_li1" style="display: flex;margin-top: 50px;">
						<div class="tzxl_li_img"><img src="../../assets/img/xxrs.png" alt=""></div>
						<div>
							<div class="tzxl_li_name">已学习人数</div>
							<div class="tzxl_li_num" style="max-width: 250px;"> {{ list.studyUserCount }}人</div>
						</div>

					</div>
					<div class="tzxl_li " style="display: flex;margin-top: 50px;">
						<div class="tzxl_li_img"><img src="../../assets/img/pjxxjd.png" alt=""></div>
						<div>
							<div class="tzxl_li_name">平均学习进度</div>
							<div class="tzxl_li_num" style="max-width: 250px;">{{ list.avgStudyProgress }}%</div>
						</div>
					</div>
				</div>


				<div class="tzxl_li tzxl_li1 pdf-group-item hover-tip" style="width: 50%;"
					v-for="(item, i) in  list.avgPaperList" :key="i">


					<div class="tzxl_li_name" style="width: 98%;" v-if="item.title">{{ item.title
					}}平均分 </div>

					<div class="tzxl_li_num" v-if="item.avgScore" style="width: 98%;">{{ item.avgScore }}分</div>
				</div>
			</div>
			<div class="xxbg-title2">
				&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;学习进度明细
				<span v-if="list.studyProgressList.length < 1" style="color: #ccc;">&nbsp;&nbsp;&nbsp;暂无数据</span>
				<span style="color: #EE3E3E;font-size: 18px;font-weight: 400;">（直播学习记录于直播次日生成统计数据）</span>
			</div>
			<div class="tabS" v-if="list.studyProgressList.length > 0">
				<el-table :data="list.studyProgressList" center border style="width: 100%">
					<el-table-column align="center" prop="userName" label="姓名">
					</el-table-column>
					<el-table-column align="center" prop="mobile" label="手机号">
					</el-table-column>
					<el-table-column align="center" prop="courseTime" label="课程时长(分钟)">
					</el-table-column>
					<el-table-column align="center" prop="studyTime" label="学习时长(分钟)">
					</el-table-column>
					<el-table-column align="center" prop="liveWatchCount" label="直播观看(场)">
					</el-table-column>
					<el-table-column align="center" prop="studyProgress" label="专题学习进度">
						<template slot-scope="scope">
							{{ scope.row.studyProgress }}%
						</template>
					</el-table-column>
				</el-table>
			</div>
			<div class="xxbg-title2 ">
				&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;课程学习明细
				<span v-if="list.studyCourseList.length < 1" style="color: #ccc;">&nbsp;&nbsp;&nbsp;暂无数据</span>
			</div>
			<div class="tabS pdf-group" v-if="list.studyCourseList.length > 0">
				<el-table :data="list.studyCourseList" center border style="width: 100%">
					<el-table-column align="center" prop="title" label="课程名称">
					</el-table-column>
					<el-table-column align="center" prop="studyUserCount" label="学习人数(人)">
						<template slot-scope="scope">
							{{ scope.row.studyUserCount }}人
						</template>
					</el-table-column>

				</el-table>
			</div>
			<div class="xxbg-title2">
				&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;未参与专题学员列表
				<span v-if="list.notStudyUserList.length < 1" style="color: #ccc;">&nbsp;&nbsp;&nbsp;暂无数据</span>
			</div>
			<div class="tabS pdf-group" v-if="list.notStudyUserList.length > 0">

				<el-table :data="[{ title: '1' }]" center border style="width: 100%">
					<el-table-column align="center" prop="title" label="姓名">

						<span v-for="(item, index) in list.notStudyUserList" :key="item.userId">{{
							item.userName }}
							<span v-if="index + 1 == list.notStudyUserList.length"></span>
							<span v-else>、</span>
						</span>
					</el-table-column>
				</el-table>

			</div>
			<div class="xxbg-title2">
				&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;考试成绩分布
				<span v-if="list.paperScoreList.length < 1" style="color: #ccc;">&nbsp;&nbsp;&nbsp;暂无数据</span>
			</div>
			<div class="cjfb pdf-group-item" v-if="list.paperScoreList">
				<div class="clfb_list" v-for="(item, inde) in list.paperScoreList" :key="inde">
					<div :id="'tu' + inde" class="clfb_list_tu "></div>
					<div class="clfb_list_tab ">
						<div
							style="width: 100%;height: 40px;overflow: hidden;text-align: center;  white-space: nowrap;font-size: 20px;margin: 0 auto;font-weight: 500;text-overflow: ellipsis;">
							{{ item.
								title }}
						</div>
						<el-table :data="item.userScoreList" center border style="width: 100%">
							<el-table-column align="center" prop="userName" label="Top榜">
							</el-table-column>
							<el-table-column align="center" prop="score" label="成绩">
								<template slot-scope="scope">
									{{ scope.row.score }} <span v-if="scope.row.score"></span>分
								</template>
							</el-table-column>

						</el-table>
					</div>
				</div>

			</div>
			<div class="xxbg-title2 ">
				&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;未考试人员
				<span v-if="list.notJoinPaperList.length < 1" style="color: #ccc;">&nbsp;&nbsp;&nbsp;暂无数据</span>
			</div>
			<div class="tabS pdf-group" v-if="list.notJoinPaperList.length > 0">
				<el-table :data="list.notJoinPaperList" center border style="width: 100%">
					<el-table-column align="center" prop="title" label="考试场次">
					</el-table-column>
					<el-table-column align="center" prop="userNames" label="缺考人员">
						<template slot-scope="scope">
							{{ scope.row.userNames.join('、') }}
						</template>
					</el-table-column>

				</el-table>
				<br><br><br><br><br><br>
			</div>
		</div>
	</div>
</template>

<script>

import Header from "@/components/Header.vue";
import { PdfLoader } from "@/utils/pdfLoader";
import { Loading } from 'element-ui';
import html2canvas from 'html2canvas'
import jsPDF from 'jspdf'
import {
	specReport

} from "@/api/index.js";

export default {

	name: "jxzt",
	components: {
		Header,
	},
	data() {
		return {
			option: {}, //图表的初始化数据
			myTheme: {}, //图标的自定义主题色
			loading: true,
			list: {
				"avgPaperList": [

				],
				"totalUserCount": 0,
				"notStudyUserList": [

				],
				"specName": "",
				"studyUserCount": 0,
				"studyCourseList": [

				],
				"companyName": "",
				"studyProgressList": [




				],
				"notJoinPaperList": [


				],
				"paperScoreList": [


				],
				"avgStudyProgress": 0
			},
			id: null, deptId: null, token: null,
		};
	},
	created() {

		this.myTheme = {
			// color: ['#5470c6', '#fac858', '#da70d6', '#91cc75'],
			color: ['#da70d6', '#5470c6', '#91cc75', '#fac858'],
		}
		this.loading = true
		//获取token
		var token = window.localStorage.getItem('token');
		var dept = window.localStorage.getItem('TopDeptId');
		if (token) {


			this.token = token;
		}
		if (dept) {
			this.deptId = dept;
		}

		this.id = this.$route.params.id
		this.getDetail()

	},
	computed: {

	},
	mounted() {


	},
	methods: {
		goHome() {

			this.$router.push("/");
			//history.back();

		},
		initChart(data, Dom, itile) {
			let chartDom = document.getElementById(Dom)
			this.option = {

				tooltip: {
					trigger: 'item',
					formatter: '{b} : {c} (人)'
				},
				legend: {
					bottom: 10,

					left: 'center'
				},
				series: [
					{
						label: {
							show: true,
							formatter: '{b}\n({c}人)'
						},
						selectedMode: 'single',
						type: 'pie',
						radius: '50%',
						data: data,
						emphasis: {
							itemStyle: {
								shadowBlur: 10,
								shadowOffsetX: 0,
								shadowColor: 'rgba(0, 0, 0, 0.5)',

							},
						}
					}
				]
			};

			// 渲染图表
			let myChart = this.$echarts.init(chartDom, this.myTheme)
			this.option && myChart.setOption(this.option)
		},
		exportPDF() {
			const loading = this.$loading({
				lock: true,
				text: "导出中",
				spinner: "el-icon-loading",
				background: "rgba(0, 0, 0, 0.7)",
			});

			const element = document.querySelector("#preview");


			const pdfLoader = new PdfLoader(element, {

				fileName: "统计报告",
				direction: "p",
				isPageMessage: true,
			});
			pdfLoader.getPdf().then((res) => {

				loading.close();
				this.$message.success("导出成功");
			});
		},

		exportPDF2() {
			this.$nextTick(() => {


				const loadingInstance = Loading.service({ fullscreen: true, text: '文件下载中...' });
				const dom = document.getElementById('preview')
				html2canvas(dom, {
					useCORS: true,//解决网络图片跨域问题
					width: dom.width,
					height: dom.height,
					windowWidth: dom.scrollWidth,
					dpi: window.devicePixelRatio * 1, // 将分辨率提高到特定的DPI 提高四倍
					scale: 3, // 按比例增加分辨率
				}).then((canvas) => {
					const pdf = new jsPDF('p', 'mm', 'a4') // A4纸，纵向
					const ctx = canvas.getContext('2d')
					const a4w = 210
					const a4h = 297 // A4大小，210mm x 297mm，四边各保留20mm的边距，显示区域170x257
					const imgHeight = Math.floor(a4h * canvas.width / a4w) // 按A4显示比例换算一页图像的像素高度
					let renderedHeight = 0
					while (renderedHeight < canvas.height) {
						const page = document.createElement('canvas')
						page.width = canvas.width
						// 可能内容不足一页
						page.height = Math.min(imgHeight, canvas.height - renderedHeight)
						// 用getImageData剪裁指定区域，并画到前面创建的canvas对象中
						page.getContext('2d').putImageData(ctx.getImageData(0, renderedHeight, canvas.width, Math.min(imgHeight, canvas.height - renderedHeight)), 0, 0)
						// 添加图像到页面
						pdf.addImage(page.toDataURL('image/jpeg', 1.0), 'JPEG', 0, 0, a4w, Math.min(a4h, a4w * page.height / page.width))
						// pdf.addImage(page.toDataURL('image/jpeg', 1.0), 'JPEG', 0, 0, a4w, a4h)
						renderedHeight += imgHeight
						if (renderedHeight < canvas.height) {
							pdf.addPage() // 如果后面还有内容，添加一个空页
						}
					}
					// 保存文件
					pdf.save(`统计报告.pdf`)
					loadingInstance.close()
				})
			})
		},




		getDetail() {
			specReport({
				specId: this.id

			}, {
				Authorization: this.token,
				DeptId: this.deptId
			}).then(res => {
				if (res.code == 200) {
					this.loading = false

					this.list = res.data
					res.data.paperScoreList.forEach((item, index) => {
						var dataS = []
						item.scoreScopeList.forEach((item2, index2) => {

							dataS.push({
								value: item2.userCount,
								name: item2.title
							})
						})

						this.$nextTick(() => {


							this.initChart(
								dataS, 'tu' + index, item.
								title)
						})
					})


				} else {
					this.loading = false
					this.$message({
						message: res.msg,
						type: 'warning'
					});
				}
			})
		},

	},
	watch: {

	},

};
</script>

<style scoped lang="less">
.fh {
	cursor: pointer;
	position: fixed;
	font-size: 20px;
	font-weight: 500;
	top: 120px;
	left: 250px;
	position: absolute;
	width: 100px;
	height: 40px;
	color: #000;


	i {
		font-size: 20px;
	}
}

.box {
	width: 100%;
	height: 100%;


}



.xxbg {
	width: 1200px;
	min-height: 820px;
	background: #FFFFFF;

	margin: 0 auto;
	border-radius: 2px;


	margin-top: 120px;


	.xxbg-title {


		width: 1000px;

		height: 60px;
		line-height: 60px;
		font-family: PingFangSC, PingFang SC;
		font-weight: 600;
		font-size: 28px;
		color: #121212;
		white-space: nowrap;
		/* 防止文本换行 */
		overflow: hidden;
		/* 隐藏超出容器的文本 */
		text-overflow: ellipsis;
		/* 显示省略号 */
		text-align: left;
		font-style: normal;
	}

	.xxbg-title2 {
		width: 100%;
		height: 33px;
		font-family: PingFangSC, PingFang SC;
		font-weight: 500;
		font-size: 24px;
		color: #3E63EE;
		line-height: 33px;
		text-align: left;
		font-style: normal;

		margin-bottom: 20px;
		position: relative;

		&:before {
			top: 5px;
			left: 0;
			position: absolute;
			display: block;
			width: 4px;
			height: 20px;
			border-radius: 10px;
			background: #3E63EE;
			content: ''


		}

	}

	.tabS {
		width: 80%;
		margin: 20px auto;
	}

	.tzxl {
		width: 80%;
		margin: 20px auto;
		display: flex;
		//justify-content: space;
		flex-wrap: wrap;

		.tzxl_li {
			width: 33%;
			min-height: 100px;
			margin-bottom: 25px;

			div {
				text-align: center;
			}

			.tzxl_li_name {
				// white-space: nowrap;
				// /* 防止文本换行 */
				// overflow: hidden;
				// /* 隐藏超出容器的文本 */
				// text-overflow: ellipsis;
				/* 显示省略号 */
				height: auto;
				font-weight: 400;
				font-size: 16px;
				color: #848F9A;
				line-height: 22px;
			}

			.tzxl_li_num {
				// white-space: nowrap;
				// /* 防止文本换行 */
				// overflow: hidden;
				// /* 隐藏超出容器的文本 */
				// text-overflow: ellipsis;
				// /* 显示省略号 */
				height: 50px;
				font-weight: 500;
				font-size: 36px;
				color: #303B45;
				line-height: 50px;
			}

			.tzxl_li_img {

				width: 120px;

				height: 100%;

				img {
					margin-top: 10px;
				}
			}
		}

		.tzxl_li1 {
			position: relative;

			&:before {
				top: 5px;
				right: 0;
				position: absolute;
				display: block;
				width: 2px;
				height: 70%;
				border-radius: 10px;
				background: #F7F8FA;
				content: ''


			}
		}
	}

	.cjfb {
		width: 80%;
		margin: 20px auto;
		display: flex;
		flex-wrap: wrap;

		.clfb_list {
			width: 40%;
			height: 620px;
			margin-right: 10%;

			.clfb_list_tu {
				height: 50%;
				width: 100%;
				margin-bottom: 10px;
			}

			.clfb_list_tab {
				height: 40%;
				width: 100%;
			}
		}
	}

}

.tabS /deep/ .el-table__header-wrapper tr th {
	background-color: #0F6CF5;
	color: #FFFFFF;
	/* 将 #f00 替换为您想要的颜色 */
}

.clfb_list_tab /deep/ .el-table__header-wrapper tr th {
	background-color: #FFBA85;
	color: #FFFFFF;
}

/deep/ .el-loading-mask {
	top: -120px !important;
	min-height: 1200px;
}
</style>